module.exports = __webpack_public_path__ + "media/images/negative-f7b3f6b926cb31a17d4928d076febab4.svg";